export const SOFTWARE_QUALITY = {
  SECURITY: 'security',
  RELIABILITY: 'reliability',
  MAINTAINABILITY: 'maintainability',
  READABILITY: 'readability',
} as const
